export default __webpack_public_path__ + "resources/icons/d240-2ccb.png";